/** Add a newly reported income source before existing rows without mutating the saved order. */
export function prependIncomeSource<T>(existing: readonly T[], newSource: T): T[] {
  return [newSource, ...existing]
}
